import React from "react";

const IconTrashcan = ({
  width = 20,
  height = 20,
  viewBox = "0 0 20 20",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.875 2.70833C6.875 1.90292 7.52792 1.25 8.33333 1.25H11.6667C12.4721 1.25 13.125 1.90292 13.125 2.70833V3.75H17.5V5H16.2248L15.4676 16.9131L15.4675 16.914C15.4053 17.9262 14.6522 18.75 13.5938 18.75H6.40625C5.3576 18.75 4.58675 17.9332 4.53229 16.9112L3.77522 5H2.5V3.75H6.875V2.70833ZM8.125 3.75H11.875V2.70833C11.875 2.59327 11.7817 2.5 11.6667 2.5H8.33333C8.21827 2.5 8.125 2.59327 8.125 2.70833V3.75ZM5.02775 5H14.9723L14.22 16.8354L14.2199 16.8369C14.1935 17.2688 13.9155 17.5 13.5938 17.5H6.40625C6.0813 17.5 5.80208 17.2636 5.78047 16.8429L5.02775 5ZM8.95833 15.625V6.875H7.70833V15.625H8.95833ZM12.2917 6.875V15.625H11.0417V6.875H12.2917Z"
      fill="#424242"
    />
  </svg>
);

export default IconTrashcan;
